import React, { useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/login', { replace: true });
    } else if (!loading && isAuthenticated && requireAdmin && 
              !(user.role === 'admin' || user.role === 'superadmin')) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, loading, user, requireAdmin, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  if (requireAdmin && !(user.role === 'admin' || user.role === 'superadmin')) {
    return null;
  }

  return children;
};

export default PrivateRoute;